/**
 * Copyright 2016, GeoSolutions Sas.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { checkForMissingPlugins } from "@mapstore/utils/DebugUtils";
import main from "@mapstore/product/main";
import "rc-slider/assets/index.css";
import { getPluginsConfiguration } from "./common/mapstore/pluginsConfiguration";

const ConfigUtils = require("@mapstore/utils/ConfigUtils").default;
/**
 * Add custom (overriding) translations with:
 *
 * ConfigUtils.setConfigProp('translationsPath', ['./MapStore2/web/client/translations', './translations']);
 */
ConfigUtils.setConfigProp("translationsPath", "./MapStore2/web/client/translations");
ConfigUtils.setConfigProp("themePrefix", "GIS_Client");

/**
 * Use a custom plugins configuration file with:
 *
 * ConfigUtils.setLocalConfigurationFile('localConfig.json');
 */
ConfigUtils.setLocalConfigurationFile("configs/localConfig.json");

/**
 * Use a custom application configuration file with:
 *
 * const appConfig = require('./appConfig');
 *
 * Or override the application configuration file with (e.g. only one page with a mapviewer):
 *
 * const appConfig = assign({}, require('@mapstore/product/appConfig'), {
 *     pages: [{
 *         name: "mapviewer",
 *         path: "/",
 *         component: require('@mapstore/product/pages/MapViewer')
 *     }]
 * });
 */
const appConfig = require("@mapstore/product/appConfig").default;
const rootEpic = require("@js/rootEpic");
const rootReducer = require("@js/rootReducer");

/**
 * Define a custom list of plugins with:
 *
 * const plugins = require('./plugins');
 */

getPluginsConfiguration().then((enabledPlugins) => {
    const plugins = require("@js/core/plugins/plugins");
    plugins.resolvePlugins(enabledPlugins);
    checkForMissingPlugins(plugins.plugins);
    const customConfig = {
        ...appConfig,
        appEpics: rootEpic.rootEpic,
        appReducers: rootReducer.rootReducer,
    };

    console.log(appConfig, customConfig);

    main(appConfig, plugins);
});
